import React, { useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Svg } from './Svg';

const CategorySlider = ({ values }) => {
    let slidesToShowByDefault = values.length > 3 ? 3 : values.length;
    let onEdgeHit = false;

    const prevBtnRef = useRef(null);
    const nextBtnRef = useRef(null);

    const CustomArrow = ({ onClick, direction = 'left', extraClass = '', elementRef = null}) => {
        return (
            <button className={`slick-arrow ${extraClass}`}
                    type="button"
                    onClick={onClick}
                    ref={elementRef}
            >
                <Svg icon="chevron" extraClass={`chevron-${direction}`} />
            </button>
        );
    };

    const OnEdge = (direction) => {
        if (!prevBtnRef.current || !nextBtnRef.current) return;

        console.log('edge was hit: ', direction);
        onEdgeHit = true;
        if (direction === 'right') {
            prevBtnRef.current.style.setProperty('display', 'none');
        } else {
            nextBtnRef.current.style.setProperty('display', 'none');
        }
    };

    const OnSwipe = (currentSlide, nextSlide) => {
        if (!prevBtnRef.current || !nextBtnRef.current) return;

        console.log('OnSwipe was hit: ', currentSlide + ': ' + nextSlide);
        if (onEdgeHit) {
            onEdgeHit = false;
            return;
        }

        prevBtnRef.current.style.setProperty('display', 'block');
        nextBtnRef.current.style.setProperty('display', 'block');
    };

    const OnInit = () => {
        if (!prevBtnRef.current) return;

        prevBtnRef.current.style.setProperty('display', 'none');
    };

    const settings = {
        onEdge: OnEdge,
        onInit: OnInit,
        beforeChange: OnSwipe,
        touchThreshold: 75,
        dots: false,
        infinite: false,
        speed: 200,
        prevArrow: <CustomArrow extraClass="slick-prev" elementRef={prevBtnRef}/>,
        nextArrow: <CustomArrow extraClass="slick-next" direction="right" elementRef={nextBtnRef}/>,
        slidesToShow: slidesToShowByDefault,
        slidesToScroll: slidesToShowByDefault,
        rtl: false,
        rows: 1,
        mobileFirst: false,
        variableWidth: true,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 300,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 400,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToScroll: 2,
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToScroll: 2,
                    slidesToShow: 5,
                },
            },
        ],
    };

    return (
        <Slider {...settings}>
            {values.map((value, index) => (
                <div
                    key={`figure${index}`}
                    dangerouslySetInnerHTML={{
                        __html: value.html,
                    }}
                ></div>
            ))}
        </Slider>
    );
};

export default CategorySlider;
